import { logError, logInfo } from '../../utils/logger';
import { queueEmail } from '../emailService';
import { EMAIL_TEMPLATES } from '../../utils/email/emailTemplates';

const generateCode = () => Math.floor(100000 + Math.random() * 900000).toString();

export const sendVerificationEmail = async (email) => {
  try {
    console.log('[EmailVerification] Starting verification process for:', email);
    
    if (!email) {
      throw new Error('Email is required');
    }

    const code = generateCode();
    const expiryTime = new Date(Date.now() + 300000).toISOString(); // 5 minutes

    console.log('[EmailVerification] Generated code and expiry time');

    // Store verification data
    localStorage.setItem('verificationCode', code);
    localStorage.setItem('verificationExpiry', expiryTime);

    console.log('[EmailVerification] Stored verification data in localStorage');

    // Send verification email
    const emailId = await queueEmail(email, 'Verify Your Email', {
      template: EMAIL_TEMPLATES.VERIFICATION,
      variables: {
        code,
        email,
        expiryTime: '5 minutes',
        expiryDate: new Date(expiryTime).toLocaleString()
      }
    });

    if (!emailId) {
      console.error('[EmailVerification] Failed to queue verification email');
      throw new Error('Failed to queue verification email');
    }

    console.log('[EmailVerification] Email queued successfully with ID:', emailId);
    logInfo('Verification code sent successfully');
    return true;
  } catch (error) {
    console.error('[EmailVerification] Error:', error);
    logError('Failed to send verification code:', error);
    // Clean up localStorage on error
    localStorage.removeItem('verificationCode');
    localStorage.removeItem('verificationExpiry');
    throw error;
  }
};

export const verifyCode = async (code) => {
  try {
    console.log('[EmailVerification] Starting code verification');
    
    const storedCode = localStorage.getItem('verificationCode');
    const expiryTime = localStorage.getItem('verificationExpiry');
    const pendingEmail = localStorage.getItem('pendingEmail');

    console.log('[EmailVerification] Retrieved from localStorage:', {
      hasStoredCode: !!storedCode,
      hasExpiryTime: !!expiryTime,
      hasPendingEmail: !!pendingEmail
    });

    if (!storedCode || !expiryTime || !pendingEmail) {
      console.error('[EmailVerification] Missing verification data');
      throw new Error('No verification in progress');
    }

    if (new Date() > new Date(expiryTime)) {
      console.error('[EmailVerification] Code expired');
      throw new Error('Verification code expired');
    }

    if (code !== storedCode) {
      console.error('[EmailVerification] Invalid code provided');
      throw new Error('Invalid verification code');
    }

    // Mark email as verified
    localStorage.setItem('emailVerified', 'true');

    console.log('[EmailVerification] Code verified successfully');
    logInfo('Email verified successfully');
    return true;
  } catch (error) {
    console.error('[EmailVerification] Verification failed:', error);
    logError('Verification failed:', error);
    throw error;
  }
};